module.exports = __webpack_public_path__ + "img/icon29.8a70eaab.png";